import { getState } from '@app/store/actions/initial'
import type { StoreDispatch } from '@app/store/dispatch'
import { createReduxSlice } from '@app/store/redux_slice'

export class MetaManager<M> {
  readonly label: string
  private defaultMeta: M
  private dispatch: StoreDispatch

  constructor(label: string, defaultMeta: M, dispatch: StoreDispatch) {
    this.label = label
    this.defaultMeta = defaultMeta
    this.dispatch = dispatch
  }

  setMeta(meta: M) {
    this.dispatch(reduxmetaSlice.update(state => ({ ...state, [this.label]: meta })))
  }

  resetMeta() {
    this.dispatch(reduxmetaSlice.update(state => ({ ...state, [this.label]: undefined })))
  }

  getMeta() {
    return this.dispatch(getState(this.selector))
  }

  selector = (state: unknown): M => {
    return reduxmetaSlice.selector(state)?.[this.label] ?? this.defaultMeta
  }
}

export const createManager =
  <M>(label: string, defaultMeta: M) =>
  (dispatch: StoreDispatch) =>
    new MetaManager(label, defaultMeta, dispatch)

const reduxmetaSlice = createReduxSlice<{ [key: string]: any }>('reduxmeta')
